export const visibleFields = ["id", "active", "fullName", "email"];

export const hiddenFields = [
	"role",
	"organizationName",
	"city",
	"declarantTypeLabel",
	"connections",
];
